import React from "react";
import { RouterProvider, useLocation } from "react-router-dom";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DeviceUpdater } from "components/DeviceUpdater";
import GlobalAlert from "components/GlobalAlert";
import PWAAlert from "components/PwaAlert";
import { ApolloContext } from "contexts/ApolloContext";
import { OidcProvider } from "contexts/OidcContext";
import { ThemeProvider } from "contexts/ThemeContext";
import { router } from "data/routes";
import ruLocale from "date-fns/locale/ru";
import AppInitializer from "./AppInitializer";
import TokenUpdater from "./TokenUpdater";

const App = () => {
  return <AppWithMemo />;
};

const AppWithMemo = React.memo(function AppWithMemo() {
  return (
    <LocalizationProvider adapterLocale={ruLocale} dateAdapter={AdapterDateFns}>
      <ApolloContext>
        <OidcProvider>
          <ThemeProvider>
            {/* <MainPage /> */}
            <DeviceUpdater />
            <RouterProvider router={router} />
            {/* <Button onClick={colorMode.toggleColorMode}>Поменять тему</Button> */}
            <TokenUpdater />
            <AppInitializer />
            <PWAAlert />
          </ThemeProvider>
        </OidcProvider>
      </ApolloContext>

      <GlobalAlert />
    </LocalizationProvider>
  );
});

export default App;
